import styled from '@emotion/styled';

export const PanelRoot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background: var(--dk-bg, #ffffff);
  border: 1px solid #000000;
  border-radius: 6px;
  box-shadow: 0 16px 32px 0 rgba(0, 0, 0, 0.08);
  max-height: 440px;
  overflow: hidden;
`;

export const SelectAllRow = styled.div<{ $focused?: boolean }>`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;
  height: 49px; /* border 포함 49 = row 48 + divider 1 */
  padding: 0 16px;
  font-size: 14px;
  line-height: 24px;
  color: var(--dk-text, #212b36);
  cursor: pointer;
  border-bottom: 1px solid #000000;
  background: ${({ $focused }) => ($focused ? 'var(--dk-bg-muted, #F3F5F6)' : 'transparent')};

  &:hover {
    background: var(--dk-bg-muted, #f3f5f6);
  }
`;

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 0;
  overflow-y: auto;
`;

export const EmptyRow = styled.div`
  padding: 24px 16px;
  text-align: center;
  font-size: 14px;
  color: var(--dk-text-dim, #b7bbc2);
`;

export const LoadingRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  font-size: 14px;
  color: var(--dk-text-strong, #637381);
`;
